import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
/**
* @public
*/
const CubeIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsxs("svg", {
		"data-sanity-icon": "cube",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: [/* @__PURE__ */ jsx("path", {
			d: "M4.5 8L12.5 3L20.5 8V17L12.5 22L4.5 17V8Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		}), /* @__PURE__ */ jsx("path", {
			d: "M12.5 22V13M12.5 13L4.5 8M12.5 13L20.5 8",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})]
	});
});
export { CubeIcon, CubeIcon as default };

//# sourceMappingURL=Cube.js.map